<script>
  import { onDestroy, onMount } from "svelte"
  import PreviewContent from "./previewContent.svelte"
  import templateStore, { templateToJSON, jsonToTemplate } from "../../../../Stores/metadataStore"
  import { removeEmptyKeys } from "../../../../Script/removeEmptyKey"
  import DocumentCarousel from "../List/Stores/documentTemplate"

  export let cardModal = false
  export let translatePosition = ""
  export let json = {}

  let unSubscribe

  /**
   * updating json data from stores while page loading
   */
  onMount(() => {
    unSubscribe = templateStore.subscribe((templateData) => {
      json = templateToJSON(templateData)
      removeEmptyKeys(json)
      if (!Object.keys(json).length) {
        json = $DocumentCarousel.template.metadata
        templateStore.update(() => {
          return jsonToTemplate(json)
        })
      }
    })
  })

  onDestroy(() => {
    unSubscribe()
  })
</script>

<div class:cardModal class="{translatePosition} relative h-fit w-full min-w-[276px] max-w-[700px] origin-top transform overflow-hidden bg-white text-left transition-all dark:bg-bodyblack">
  <div class="w-full transform select-none break-all rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0">
    <div class="flex w-full items-center justify-between bg-blue-500 p-6 text-gray-900">
      <h1 class="break-title select-none text-xl font-medium text-white">Blockchain Verified - More Info</h1>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <span on:click>
        <i class="fa-solid fa-xmark fa-lg cursor-pointer text-white" />
      </span>
    </div>
    <div class="wordBreak p-6 pb-3 pl-0">
      <PreviewContent {json} />
    </div>
    <div class="flex flex-row-reverse border-t border-t-[#e9ecef] bg-white p-6 dark:border-darkgray dark:bg-bodyblack">
      <button on:click type="button" class="inline-flex justify-center rounded-full border border-transparent bg-blue-500 px-3 py-1.5 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring active:bg-blue-500 sm:ml-3 sm:text-sm">Close</button>
    </div>
  </div>
</div>

<style global>
  .cardModal {
    transform: rotateX(0deg) rotateZ(0deg) rotateY(0deg) translateX(0px);
    scale: 1;
    transform-style: preserve-3d;
  }

  .start {
    animation: 1s linear normalanim;
    animation-fill-mode: forwards;
  }
  .break-title {
    word-break: break-word;
  }

  @keyframes normalanim {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
